import { useEffect } from 'react';
import axios from 'axios';

const Collect = ({ name = 'unknown' }) => {
  useEffect(() => {
    const sendCollect = async () => {
      try {
        await axios.get('/collect', {
          params: { name },
          withCredentials: true,
        });
        console.log(`Collect sent with name: ${name}`);
      } catch (error) {
        console.error('Error sending collect:', error);
      }
    };

    // Send initial collect
    sendCollect();

    // Set interval for hourly collects (3600000 ms)
    const interval = setInterval(sendCollect, 3600000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [name]);

  return null; // This component doesn't render anything
};

export default Collect;